import { useContext } from "react";
import { AuthenticationContext } from "../../shared/providers/authentication/authentication.provider";
import { TranslationContext } from "../../shared/providers/translation/translation.provider";

function ProfilePicture() {
    const { user } = useContext(AuthenticationContext);
    const { translate } = useContext(TranslationContext);
    return (
        <div className="profile">
            <div className="profile_thumbnail bg-blue-100 color-blue-500 d-flex align-items-center justify-content-center">
                <i className={`icon icon-32 icon-user`}></i>
            </div>
            <div className="profile_info">
                <span className="text-bd3-rg color-neutrals-black">
                    {user?.firstName ? `${user?.firstName} ${user?.lastName}` : user?.email}
                </span>
                <span className="text-bd3-light color-neutrals-neutral">{translate(`account.role.${user?.jobTitle.code}`, user?.jobTitle.code ?? "")}</span>
            </div>
        </div>
    );
}

export default ProfilePicture;
